<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-11 10:25:21
 * @LastEditors: whaoo
 * @LastEditTime: 2024-05-14 16:50:29
-->
<template>
  <div class="container">
    <div class="flex_space_between search_box">
      <div class="flex_start">
        <div class="flex_start_center mr_24">
          <div class="mr_12">床位号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.bed_number"></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_24">
          <div class="mr_12">患者住院号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.patient_id"></el-input>
          </div>
        </div>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table :data="tableData" v-loading="loading" align="center" border>
      <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
      <el-table-column prop="patient_id" label="住院号" align="center"></el-table-column>
      <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
      <el-table-column prop="today_walk" label="今日步数（步）" align="center"></el-table-column>
      <el-table-column prop="calorie" label="消耗卡路里（kcal）" align="center"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button plain type="primary" size="small" @click="historyReport(scope.row)">历史运动报告</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[10, 15, 20, 25]" :page-size="perPage" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <el-dialog :visible.sync="reportDialogFlag" width="750px" :top="!sportNoData ? '5vh' : '15vh'">
      <div slot="title" class="flex_start_center">
        <div class="custom_title">{{ reportPatientItme.bed_number }}床 {{ reportPatientItme.name }}</div>
        <div>
          <el-date-picker size="small" v-model="reportDate" type="date" placeholder="选择日期"
            :picker-options="pickerOptions" @change="dateChange"></el-date-picker>
        </div>
      </div>

      <div v-show="sportNoData" class="nodata" v-loading="dialogLoading">
        <img src="@/assets/icon/nodata.png" />
        <div>当日暂无运动数据~</div>
      </div>
      <div v-show="!sportNoData">
        <div class="dialog_body" v-loading="dialogLoading">
          <div class="dialog_body_title">运动强度分布</div>
          <div class="flex_center_center mb_24">
            <div class="radiu_chart" id="sport_chart"></div>
            <div class="radiu_legend">
              <div class="legend_item mb_24">
                <div class="circle"></div>
                <div class="text">低强度</div>
                <div class="percent">{{ sportData.per_low_sport }}%</div>
              </div>
              <div class="legend_item mb_24">
                <div class="circle"></div>
                <div class="text">中强度</div>
                <div class="percent">{{ sportData.per_mid_sport }}%</div>
              </div>
              <div class="legend_item">
                <div class="circle"></div>
                <div class="text">高强度</div>
                <div class="percent">{{ sportData.per_high_sport }}%</div>
              </div>
            </div>
          </div>
          <div class="flex_space_between statics_data">
            <div class="statics_data_item">
              <div>
                <span class="num">{{ sportData.today_walk }}</span>
                <span>步</span>
              </div>
              <div>步数</div>
            </div>
            <div class="statics_line"></div>
            <div class="statics_data_item">
              <div>
                <span class="num">{{ sportData.calorie }}</span>
                <span>kcal</span>
              </div>
              <div>卡路里</div>
            </div>
            <div class="statics_line"></div>
            <div class="statics_data_item">
              <div>
                <span class="num">{{ sportData.kilometers }}</span>
                <span>km</span>
              </div>
              <div>运动距离</div>
            </div>
          </div>

          <div class="flex_space_between">
            <div class="dialog_body_title">体征趋势对比图</div>
            <div class="flex_start_center legend_2">
              <div class="line line_1"></div>
              <div>今日</div>
              <div class="line line_2"></div>
              <div>第一天</div>
            </div>
          </div>
          <div class="line_chart" id="hr_chart"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
const ReportUrl = process.env.REPORT_API;
const sportOpitons = {
  color: ["#CCE4FD", "#80BBFB", "#0076F6"],
  grid: {
    left: "0",
    top: "0",
    right: "0",
    bottom: "0",
  },
  series: [
    {
      type: "pie",
      radius: ["70%", "90%"],
      labelLine: {
        show: false,
      },
      label: {
        show: false,
        position: "center",
      },
      data: [
        { value: 0, name: "低强度" },
        { value: 0, name: "中强度" },
        { value: 0, name: "高强度" },
      ],
    },
    {
      z: 100,
      type: "gauge",
      radius: "-50%",
      // center: ['25%', '45%'],// 需和type: 'pie'中的center一致
      // 配置中间的数字的样式
      detail: {
        // 调节数字位置
        offsetCenter: [-0, -14],
        color: "#0076F6",
        formatter: "{value}",
        fontSize: "32",
        fontWeight: "bold",
      },
      pointer: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
      // 中间的字和数字 数据
      data: [
        {
          value: 0,
          name: "总时间（分钟）",
          title: {
            show: true,
            color: "#9296AF",
            offsetCenter: [0, "-40%"],
            fontSize: 16,
          },
        },
      ],
    },
  ],
};

const hrOptions = {
  grid: {
    left: "5%",
    top: "10%",
    right: "2%",
    bottom: "10%",
  },
  xAxis: {
    type: "time",
    data: [],
    splitNumber: 25,
    axisLabel: {
      color: "#9296AF",
      formatter: "{HH}:{mm}",
      // interval:5
      hideOverlap: true,
    },
    axisLine: {
      lineStyle: {
        color: "#EEEEEE",
      },
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
      interval: 0,
      lineStyle: {
        color: "#9296AF",
      },
    },
  },
  yAxis: {
    type: "value",
    axisLabel: {
      color: "#9296AF",
    },
    splitLine: {
      lineStyle: {
        color: "#EEEEEE",
      },
    },
    min: 0,
    max: 180,
    interval: 30,
  },
  backGroundColor: "#000000",
  series: [
    {
      data: [],
      type: "line",
      connectNulls: false,
      lineStyle: {
        color: "#9296AF",
        width: "2",
      },
      symbol: "none",
    },
    {
      data: [],
      type: "line",
      connectNulls: false,
      lineStyle: {
        color: "#07C160",
        width: "2",
      },
      symbol: "none",
    },
  ],
};
export default {
  data() {
    return {
      searchForm: {
        bed_number: "",
        patient_id: "",
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,
      zone_number: "",
      reportDialogFlag: false,
      reportPatientItme: {},
      reportDate: "",
      pickerOptions: {
        disabledDate(date) {
          return new Date() < date;
        },
      },
      dialogLoading: false,
      sportData: {},
      sportNoData: true,
      patient_item: {}
    };
  },

  mounted() {
    if (!this.$cookies.get("token")) {
      this.$router.push("/login");
    }
    this.zone_number = this.$cookies.get("zone_number");
    this.fetchData();
  },

  methods: {
    reset() {
      this.searchForm.bed_number = "";
      this.searchForm.patient_id = "";
      this.page = 1;
      this.fetchData();
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number,
        bed_number: this.searchForm.bed_number,
        patient_id: this.searchForm.patient_id,
      };
      if (data.bind == "0") {
        delete data.bind;
      }
      this.$http({
        url: "/api/report/sport_list",
        method: "POST",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        const result = res.result;
        this.tableData = result.data;
        this.total = result.total;
        this.loading = false;
      });
    },
    historyReport(item) {
      this.reportPatientItme = item;
      this.reportDialogFlag = true;
      this.reportDate = new Date();
      this.patient_item = item
      this.fecthReportData();
    },
    fecthReportData() {
      this.dialogLoading = true;
      let date = this.$dateFtt.dateFtt("yyyyMMdd", this.reportDate);
      axios
        .get(ReportUrl + "/hospital_show/api/report/sport_report", {
          params: {
            date: date,
            patient_id: this.patient_item.patient_id,
            md5: this.md5Str(this.patient_item.patient_id),
            // date: "20240509",
            // patient_id: "60015158917",
            // md5: this.md5Str("60015158917"),
          },
        })
        .then((response) => {
          console.log(response);
          const result = response.data;
          if (result.state == 200) {
            this.sportNoData = false;
            this.setSportEchart(result);
            this.setHrEchart(result);
            this.sportData = result;
          } else {
            this.sportNoData = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.sportNoData = true;
        })
        .finally(() => {
          setTimeout(() => {
            this.dialogLoading = false;
          }, 100);
        });
    },
    setSportEchart(data) {
      let chartDom = document.getElementById("sport_chart");
      let myChart = echarts.init(chartDom);
      let option = sportOpitons;
      option.series[0].data[0].value = data.per_low_sport;
      option.series[0].data[1].value = data.per_mid_sport;
      option.series[0].data[2].value = data.per_high_sport;
      option.series[1].data[0].value = data.total_time;
      option && myChart.setOption(option);
    },
    setHrEchart(data) {
      let chartDom = document.getElementById("hr_chart");
      let myChart = echarts.init(chartDom);
      let option = hrOptions;
      let date = this.$dateFtt.dateFtt("yyyy-MM-dd ", this.reportDate);

      let data_0 = [[new Date(date + "00:00:00").getTime(), '']],
        data_1 = [[new Date(date + "00:00:00").getTime(), '']];
      for (const key in data.T0_day_heartrate) {
        if (Object.hasOwnProperty.call(data.T0_day_heartrate, key)) {
          const element = data.T0_day_heartrate[key];
          data_0.push([new Date(date + key).getTime(), element]);
        }
      }
      for (const key in data.today_heartrate) {
        if (Object.hasOwnProperty.call(data.today_heartrate, key)) {
          const element = data.today_heartrate[key];
          data_1.push([new Date(date + key).getTime(), element]);
        }
      }
      data_0[data_0.length] = [new Date(date + "23:59:59").getTime(), ''];
      data_1[data_1.length] = [new Date(date + "23:59:59").getTime(), ''];
      option.series[0].data = data_0;
      option.series[1].data = data_1;
      option && myChart.setOption(option);
    },
    dateChange() {
      this.fecthReportData();
    },
  },
};
</script>
<style scoped>
.custom_title {
  color: #252b50;
  font-size: 18px;
  font-weight: bolder;
  margin-right: 20px;
}

.radiu_chart {
  width: 210px;
  height: 210px;
}

.mb_24 {
  margin-bottom: 24px;
}

.dialog_body {
  width: 100%;
}

.dialog_body_title {
  color: #252b50;
  font-weight: bold;
  font-size: 16px;
}

.legend_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  padding-left: 32px;
}

.legend_item:nth-child(1) .circle {
  background-color: #cce4fd;
}

.legend_item:nth-child(2) .circle {
  background-color: #80bbfb;
}

.legend_item:nth-child(3) .circle {
  background-color: #0076f6;
}

.legend_item .circle {
  width: 12px;
  height: 12px;
  border-radius: 12px;
  margin-right: 6px;
}

.legend_item .text {
  color: #9296af;
  margin-right: 8px;
}

.legend_item .percent {
  color: #636676;
}

.statics_data {
  padding: 0 110px;
  height: 100px;
  background: #f5f7fb;
  border-radius: 8px;
  color: #9296af;
  text-align: center;
  margin-bottom: 20px;
}

.statics_data_item .num {
  color: #252b50;
  font-size: 32px;
  font-weight: bold;
}

.statics_line {
  width: 1px;
  background-color: #d9d9d9;
  height: 24px;
}

.line {
  width: 12px;
  height: 3px;
  border-radius: 3px;
}

.line_1 {
  background-color: #07c160;
}

.line_2 {
  background-color: #9296af;
}

.legend_2 {
  font-size: 12px;
  color: #9296af;
}

.legend_2 div {
  margin-left: 5px;
}

.line_chart {
  width: 710px;
  height: 300px;
}

.nodata {
  text-align: center;
  padding: 40px 0 60px;
  font-size: 14px;
  color: #929faf;
}

.nodata img {
  width: 162px;
}
</style>


// WEBPACK FOOTER //
// src/view/managePages/activity_report.vue